// components/Forms/EditarGravidezForm.js
import React, { useState } from "react";
import {
  FormContainer,
  FormHeader,
  FormField,
  SubmitButton,
  Message,
} from "./EditarGravidezForm.styles";
import api from "../../services/api";
import ConfirmModal from "../Modals/ConfirmModal";

const formatToInputDate = (dateStr) => {
  // Verifica se a data está no formato dd/mm/yyyy
  if (!dateStr || typeof dateStr !== "string") return "";

  const [day, month, year] = dateStr.split('/');
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};

const EditarGravidezForm = ({ gravidez, onClose }) => {

  const [formValues, setFormValues] = useState({
    gestante_cpf: gravidez.gestante_cpf,
    id: gravidez.id,
    dum: formatToInputDate(gravidez.data),
    qtd_filhos: gravidez.qtd_filhos || 1,
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [qtdConsultasRemover, setQtdConsultasRemover] = useState(0);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = async (e, removerConsultas = false) => {
    if (e) e.preventDefault();
    setIsSubmitting(true);
    setSuccessMessage("");
    setErrorMessage("");

    try {
      await api.put(
        `/gestante/${formValues.gestante_cpf}/gravidez/${formValues.id}/update`,
        {
          dum: formValues.dum,
          qtd_filhos: parseInt(formValues.qtd_filhos),
          remover_consultas_anteriores_dum: removerConsultas,
        }
      );

      setSuccessMessage("Gestação atualizada com sucesso!");
      setTimeout(() => {
        onClose();
      }, 1500);
    } catch (error) {
      const detail = error.response?.data?.detail;
      // Verifica se é o erro específico de consultas anteriores à DUM
      if (detail?.error === "EXISTS_CONSULTATIONS_BEFORE_DUM") {
        setQtdConsultasRemover(detail.qtd_consultas);
        setShowConfirmModal(true);
        return;
      }
      
      // Para outros erros, garantir que seja uma string
      const errorMsg = typeof detail === 'string' 
        ? detail 
        : "Erro ao conectar com o servidor.";
      setErrorMessage(errorMsg);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleConfirmRemoverConsultas = () => {
    setShowConfirmModal(false);
    handleSubmit(null, true);
  };

  return (
    <FormContainer>
      <FormHeader>Editar Gestação</FormHeader>
      <form onSubmit={handleSubmit}>
        <FormField>
          <label>Data da Última Menstruação (DUM):</label>
          <input
            type="date"
            name="dum"
            value={formValues.dum}
            onChange={handleChange}
            required
          />
        </FormField>

        <FormField>
          <label>Quantidade de Filhos:</label>
          <input
            type="number"
            name="qtd_filhos"
            value={formValues.qtd_filhos}
            onChange={handleChange}
            min={1}
            required
          />
        </FormField>

        <SubmitButton type="submit" disabled={isSubmitting}>
          {isSubmitting ? "Salvando..." : "Salvar Alterações"}
        </SubmitButton>
      </form>

      {successMessage && <Message>{successMessage}</Message>}
      {errorMessage && <Message isError>{errorMessage}</Message>}

      <ConfirmModal
        isOpen={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        onConfirm={handleConfirmRemoverConsultas}
        title="Confirmar alteração da DUM"
        message={`Não são admitidas consultas de pré-natal com data anterior à data da última menstruação, portanto ao alterar a data da última menstruação as ${qtdConsultasRemover} consulta(s) anteriores serão excluídas automaticamente. Você tem certeza que quer alterar a DUM?`}
        confirmText="Sim, alterar DUM"
        cancelText="Cancelar"
      />
    </FormContainer>
  );
};

export default EditarGravidezForm;
